import { DomainBase } from "./DomainBase";

export   class TableAssignment extends DomainBase {
    constructor() {
        super();
        this.Section = null;
        this.Tables = [];
    }
}